<template>
  <div>
    <div class="filters-wrapper flex justify-between">
      <div class="w-1/5">
        <treeselect
          v-model="selectedCategory"
          class="h-10"
          :multiple="false"
          :options="categories"
          :closeOnSelect="true"
          :clearable="false"
          :clearOnSelect="true"
          :isDefaultExpanded="true"
          :defaultExpandLevel="1"
          :showCount="true"
          :max-height="200"
          :normalizer="normalizer"
          @input="resetDefautsAndLoad"
          :placeholder="$t('frontend_groovevideo_videos_index_affiliate_types')"
        />
      </div>
      <div class="flex justify-between space-x-5">
        <gd-dropdown
          :options="timeOptions"
          class="text-sm text-grey-700 h-10"
          v-model="selectedOrder"
          size="full"
          @change="resetDefautsAndLoad"
          :style="{ maxHeight }"
        ></gd-dropdown>
        <div
          class="
            flex
            items-center
            border
            rounded-lg
            border-grey-300
            pl-2
            text-grey-300
          "
        >
          <i class="fa fa-search"></i>
          <text-input
            v-model="searchFileName"
            class="text-sm border-none"
            :placeholder="'Search'"
            v-debounce:1s="resetDefautsAndLoad"
          />
        </div>
      </div>
    </div>
    <table class="w-full files-wrapper">
      <thead class="w-full text-left border-b">
        <th class="p-5"></th>
        <th class="p-5">S. No.</th>
        <th class="p-5">Name</th>
        <th class="p-5">File Type</th>
        <th class="p-5">Category Name</th>
        <th class="p-5">Size</th>
      </thead>
      <tbody>
        <tr v-for="(file, index) in files" :key="index" class="border-b">
          <td class="p-5 cursor-pointer" @click="selectFile(file)">
            <span
              :key="selectedFile.id"
              v-if="selectedFile.id == file.id"
              class="
                h-4
                w-4
                flex
                items-center
                justify-center
                border
                font-normal
              "
            >
              <i class="fa fa-check text-xs"></i>
            </span>
            <span
              :key="selectedFile.id"
              v-else
              class="
                h-4
                w-4
                flex
                items-center
                justify-center
                border
                font-normal
              "
            >
            </span>
          </td>
          <td class="p-5">{{ index + 1 }}</td>
          <td class="p-5">{{ file.name }}</td>
          <td class="p-5 capitalize">
            {{ file.original_name.split('.').at(-1) }}
          </td>
          <td class="p-5">{{ file.category_name }}</td>
          <td class="p-5">{{ file.size }}</td>
        </tr>
      </tbody>
    </table>
    <infinite-loading
      ref="infiniteLoading"
      @infinite="infiniteHandler"
      spinner="spiral"
      :identifier="infiniteId"
    >
      <div class="text-grey-800 mt-5" slot="no-more">No More Files</div>
      <div class="text-grey-800 mt-5" slot="no-results">No More Files</div>
    </infinite-loading>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'MyFiles',
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          id: 0,
        };
      },
    },
    allowedFiles: {},
  },
  data() {
    return {
      hasNext: true,
      infiniteId: +new Date(),
      page: 1,
      limit: 12,
      searchFileName: '',
      selectedCategory: 0,
      selectedOrder: 'id-desc',
      files: [],
      categories: [],
      selectedFile: {},
      maxHeight: { 'max-height': '100px' },
    };
  },
  components: {
    InfiniteLoading,
    Treeselect,
  },
  computed: {
    timeOptions() {
      return [
        {
          value: 'name-asc',
          text: this.$t('frontend_groovevideo_timeoptions_name_asc'),
        },
        {
          value: 'name-desc',
          text: this.$t('frontend_groovevideo_timeoptions_name_desc'),
        },
        {
          value: 'id-asc',
          text: this.$t('frontend_groovevideo_timeoptions_first_created'),
        },
        {
          value: 'id-desc',
          text: this.$t('frontend_groovevideo_timeoptions_last_created'),
        },
        {
          value: 'updated_at-asc',
          text: this.$t('frontend_groovevideo_timeoptions_first_updated'),
        },
        {
          value: 'updated_at-desc',
          text: this.$t('frontend_groovevideo_timeoptions_last_updated'),
        },
      ];
    },
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.category,
        children: node.child && node.child.length ? node.child : undefined,
        user_id: node.user_id,
      };
    },
    selectFile(file) {
      this.selectedFile = { ...file };

      if (this.selectedFile.id > 0) {
        this.emitSelection();
      }
    },
    emitSelection() {
      this.$emit('selected', this.selectedFile);
    },
    async resetDefautsAndLoad() {
      this.page = 1;
      this.files = [];
      this.infiniteId += 1;
    },
    infiniteHandler($state) {
      this.loadFiles().then((newFiles) => {
        if (newFiles.length > 0) {
          this.page += 1;
          this.files.push(...newFiles);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    async loadFiles() {
      try {
        const FileData = await api.get(
          `${window.config.apiCoreUrl}/groovemember/membership/file?filter[category_id]=${this.selectedCategory}&filter[name]=${this.searchFileName}&filter[sort]=${this.selectedOrder}&filter[page]=${this.page}&filter[limit]=${this.limit}&filter[allowedFiles]=${this.allowedFiles}`
        );

        return FileData.data;
      } catch (err) {
        return [];
      }
    },
    async loadCategories() {
      try {
        const categoryData = await api
          .get(
            `${window.config.apiCoreUrl}/groovemember/file-category?childGrouping=true`
          )
          .then((d) => d.data);

        return [
          { id: 0, category: 'All Categories', user_id: 0 },
          ...categoryData,
        ];
      } catch (err) {
        return [{ id: 0, category: 'All Categories', user_id: 0 }];
      }
    },
  },
  async mounted() {
    try {
      this.categories = await this.loadCategories();
      this.selectFile(this.value);
    } catch (err) {
      /** */
    }
  },
};
</script>